import { useNavigate } from 'react-router-dom';
import type { Event } from '@/types';

interface EventCardProps {
  event: Event;
}

export function EventCard({ event }: EventCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/mypage/events/${event.id}`);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const isEventActive = () => {
    const now = new Date();
    const startDate = new Date(event.start_date);
    const endDate = new Date(event.end_date);
    return now >= startDate && now <= endDate;
  };

  const isEventUpcoming = () => {
    const now = new Date();
    const startDate = new Date(event.start_date);
    return now < startDate;
  };

  const getEventStatus = () => {
    if (isEventActive()) {
      return { text: '진행중', className: 'bg-green-100 text-green-800' };
    } else if (isEventUpcoming()) {
      return { text: '예정', className: 'bg-blue-100 text-blue-800' };
    } else {
      return { text: '종료', className: 'bg-gray-100 text-gray-800' };
    }
  };

  const status = getEventStatus();

  return (
    <button
      onClick={handleClick}
      className="w-full p-4 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow text-left"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-[#222222] mb-1">
            {event.name}
          </h3>
          <span className={`inline-block px-2 py-1 text-xs font-medium rounded whitespace-nowrap ${status.className}`}>
            {status.text}
          </span>
        </div>
      </div>
      
      {event.summary && (
        <p className="text-gray-600 text-sm mb-3 line-clamp-2">
          {event.summary}
        </p>
      )}
      
      <div className="flex items-center justify-between text-sm text-gray-500">
        <span>
          {formatDate(event.start_date)} ~ {formatDate(event.end_date)}
        </span>
      </div>
      
      {event.max_participants && (
        <div className="mt-2 text-xs text-gray-500">
          참가자: {event.current_participants || 0}/{event.max_participants}
        </div>
      )}
    </button>
  );
}
